import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/impostazioni/profilo')({
  head: () => noIndexRouteHead('settingsProfile', 'it'),
  component: ProfileSettingsPage,
})
